import React, { Component } from "react";
import Link from "gatsby-link";
import hoistStatics from 'hoist-non-react-statics';

const NavLink = props => <Link to={props.url}>{props.text}</Link>;

const PaginatedPage = WrappedComponent => {
    const Connect = props => {
        const { group, index, pageCount } = props.pathContext;
        const pathPrefix = 'page';
        const previousUrl = index - 1 == 1 ? "" : `/${pathPrefix}/${(index - 1).toString()}`;
        const nextUrl =`/${pathPrefix}/${(index + 1).toString()}`;
        return (
            <div>
                <WrappedComponent {...{group}} />
                <nav className="navigation posts-navigation" role="navigation">
                    <h2 className="screen-reader-text">Posts navigation</h2>
                    <div className="nav-links">
                        {index < pageCount &&
                            <div className="nav-next">
                                <NavLink url={nextUrl} text="Older posts" />
                            </div>
                        }
                        {index > 1 && 
                            <div className="nav-previous">
                                <NavLink url={previousUrl} text="Newer posts" />
                            </div>
                        }
                    </div>
                </nav>
            </div>
        )
    }

    return hoistStatics(Connect, WrappedComponent)
}

export default PaginatedPage;


// WEBPACK FOOTER //
// ./src/templates/index.paginate.js